import { Input } from "design-react-kit";
import moment from "moment";
import { useEffect, useState, useContext } from "react";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import { Link, useLocation } from "react-router-dom";
import Select from "../../Components/Select";
import { PROVINCE } from "../../Components/listaProvince";
import { NAZIONI } from "../../Components/listaNazioni";
import { TokenContext } from "../../Components/TokenContext";
import Pagination from "../../Components/Pagination";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useRef } from "react";
import ListPaymemtsUsers from "../../Components/listPaymentsUser";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function UserProfile(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [validation, setValidation] = useState(false);
  const [validationBirth, setValidationBirth] = useState(true);
  const [user, setUser] = useState({});
  const [payments, setPayments] = useState();
  const [paymentsTemp, setPaymentsTemp] = useState();
  const [isDisabled, setIsDisabled] = useState(true);
  const [listaProvince] = useState(PROVINCE);
  const [listaNazioni] = useState(NAZIONI);
  const [listaMunicipi, setListaMunicipi] = useState();
  const [userIsees, setUserIsees] = useState();
  const [userIseesTemp, setUserIseesTemp] = useState();
  const ref = useRef();

  let query = useQuery();

  useEffect(() => {
    if (query.get("scroll")) {
      window.scrollTo(0, ref.current.offsetHeight + 150);
    }

    Repo.getUser(apiToken)
      .then((response) => {
        setUser(response.data);
        setUserIseesTemp(response.data.isees);
      })
      .catch((error) => {
        console.log(error);
      });

    Repo.getPagamentiUtenti(apiToken)
      .then((response) => {
        setPaymentsTemp(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    Repo.getMunicipi(apiToken)
      .then((response) => {
        setListaMunicipi(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const userEditValidation = () => {
    setValidation(true);
    let passedValidation = true;

    Object.entries(user).map(([key, value]) => {
      //isArray is used to exclude the isees array in the validation

      if (
        (value == "" || value == null) &&
        !Array.isArray(value) &&
        key !== "emailPec" &&
        key !== "phoneNumber" &&
        key !== "municipioId" &&
        key !== "emailStatus" &&
        key !== "municipio"
      ) {
        passedValidation = false;
      }

      if (key == "birthDate") {
        if (value == "" || value == null) {
          setValidationBirth(false);
          passedValidation = false;
        } else if (user.birthDate.isValid && !user.birthDate.isValid()) {
          setValidationBirth(false);
          passedValidation = false;
        }
      }
    });

    if (passedValidation) {
      user.birthdate = moment(user.birthDate, "DD/MM/YYYY")
        .format("YYYY-MM-DD")
        .toString();

      setUser({ ...user });

      toggleModal(!isOpen);
    }
  };

  const editUserAPI = () => {
    Repo.postUser(apiToken, JSON.stringify(user))
      .then((response) => {
        if (response.status == 200) {
          window.location.href = props.subfolder + "/";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div>
        <h1>Profilo</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p></p>
        </div>
        <div className="col-lg-12 mt-3">
          <div className="card-wrapper card-space">
            <div className="card card-bg no-after card-big roundedCustom">
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-4">
                    <Input
                      id="firstName"
                      disabled={true}
                      label="Nome*"
                      type="text"
                      name="firstName"
                      value={user.firstName || ""}
                      style={{ cursor: "not-allowed" }}
                    />
                  </div>
                  <div className="col-lg-4">
                    <Input
                      id="last_name"
                      disabled={true}
                      label="Cognome*"
                      type="text"
                      name="last_name"
                      value={user.lastName || ""}
                      style={{ cursor: "not-allowed" }}
                    />
                  </div>
                  <div className="col-lg-4">
                    <Input
                      id="fiscal_code"
                      disabled={true}
                      label="Codice Fiscale*"
                      type="text"
                      name="fiscal_code"
                      value={user.fiscalCode || ""}
                      style={{ cursor: "not-allowed" }}
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-lg-3">
                    <Input
                      id="birthdate"
                      label="Data di Nascita*"
                      type="date"
                      name="birthdate"
                      placeholder="gg/mm/aaaa"
                      disabled={isDisabled}
                      value={
                        user && user.birthDate != null
                          ? moment(user.birthDate, "DD/MM/YYYY")
                              .format("YYYY-MM-DD")
                              .toString()
                          : ""
                      }
                      onChange={(e) =>
                        setUser({
                          ...user,
                          birthDate: moment(e.target.value),
                        })
                      }
                      {...(validation &&
                        !validationBirth && {
                          infoText: "Il campo non può essere vuoto!",
                          className: "text-danger error_div is-invalid",
                        })}
                    />
                  </div>
                  <div className="col-lg-4">
                    <Input
                      id="email"
                      disabled={isDisabled}
                      label="Email*"
                      type="text"
                      name="email"
                      value={user.email || ""}
                      onChange={(e) =>
                        setUser({ ...user, email: e.target.value })
                      }
                      {...(validation &&
                        !user.email && {
                          infoText: "Il campo non può essere vuoto!",
                          className: "text-danger error_div is-invalid",
                        })}
                    />
                  </div>
                  <div className="col-lg-3">
                    <Input
                      id="emailPec"
                      disabled={isDisabled}
                      label="Pec"
                      type="text"
                      name="emailPec"
                      value={user && user.emailPec ? user.emailPec : ""}
                      onChange={(e) =>
                        setUser({ ...user, emailPec: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-lg-2">
                    <Input
                      id="phone_number"
                      disabled={isDisabled}
                      label="Telefono"
                      type="text"
                      name="phone_number"
                      value={user.phoneNumber || ""}
                      onChange={(e) =>
                        setUser({ ...user, phoneNumber: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-lg-6">
                    <Input
                      id="address"
                      disabled={isDisabled}
                      label="Indirizzo*"
                      type="text"
                      name="address"
                      value={user.address || ""}
                      onChange={(e) =>
                        setUser({ ...user, address: e.target.value })
                      }
                      {...(validation &&
                        !user.address && {
                          infoText: "Il campo non può essere vuoto!",
                          className: "text-danger error_div is-invalid",
                        })}
                    />
                  </div>
                  <div className="col-lg-3">
                    <Input
                      id="number"
                      disabled={isDisabled}
                      label="N. Civico*"
                      type="text"
                      name="number"
                      value={user.addressNumber || ""}
                      onChange={(e) =>
                        setUser({ ...user, addressNumber: e.target.value })
                      }
                      {...(validation &&
                        !user.addressNumber && {
                          infoText: "Il campo non può essere vuoto!",
                          className: "text-danger error_div is-invalid",
                        })}
                    />
                  </div>
                  <div className="col-lg-3">
                    <Input
                      id="cap"
                      disabled={isDisabled}
                      label="CAP*"
                      type="text"
                      name="cap"
                      value={user.cap || ""}
                      onChange={(e) =>
                        setUser({ ...user, cap: e.target.value })
                      }
                      {...(validation &&
                        !user.cap && {
                          infoText: "Il campo non può essere vuoto!",
                          className: "text-danger error_div is-invalid",
                        })}
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-lg-4">
                    <Input
                      id="city"
                      disabled={isDisabled}
                      label="Città*"
                      type="text"
                      name="city"
                      value={user.city || ""}
                      onChange={(e) =>
                        setUser({ ...user, city: e.target.value })
                      }
                      {...(validation &&
                        !user.city && {
                          infoText: "Il campo non può essere vuoto!",
                          className: "text-danger error_div is-invalid",
                        })}
                    />
                  </div>
                  <div className="col-lg-4">
                    <div className="bootstrap-select-wrapper col-12">
                      <Select
                        aria-label="Scegli una provincia*"
                        clearText="Annulla"
                        isDisabled={isDisabled}
                        defaultMenuIsOpen={false}
                        icon={false}
                        id="selectExampleClassic"
                        onChange={(e) => {
                          setUser({ ...user, country: e.value });
                        }}
                        options={listaProvince}
                        isSearchable
                        placeholder={
                          user && user.country
                            ? user.country
                            : "Scegli una provincia"
                        }
                      />
                    </div>
                    {validation && !user.country ? (
                      <small
                        id="errorSelect"
                        className="form-text  text-danger"
                      >
                        Il campo non può essere vuoto!
                      </small>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="col-lg-4 ">
                    <div className="select-wrapper col-12">
                      <Select
                        aria-label="Scegli una provincia*"
                        clearText="Annulla"
                        isDisabled={isDisabled}
                        defaultMenuIsOpen={false}
                        icon={false}
                        id="selectExampleClassic"
                        onChange={(e) => setUser({ ...user, nation: e.value })}
                        options={listaNazioni}
                        isSearchable
                        placeholder={
                          user && user.nation
                            ? user.nation
                            : "Scegli una Nazione"
                        }
                      />
                    </div>
                    {validation && !user.nation ? (
                      <small
                        id="errorSelect"
                        className="form-text  text-danger"
                      >
                        Il campo non può essere vuoto!
                      </small>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="bootstrap-select-wrapper col-12">
                    <Select
                      aria-label="Scegli un municipio*"
                      clearText="Annulla"
                      isDisabled={isDisabled}
                      defaultMenuIsOpen={false}
                      icon={false}
                      id="selectExampleClassic"
                      onChange={(e) =>
                        setUser({ ...user, municipioId: e.value })
                      }
                      options={listaMunicipi}
                      isSearchable
                      placeholder={
                        user && user.municipio
                          ? ('Municipio ' + user.municipio.id)
                          : "Scegli un municipio"
                      }
                    />
                  </div>
                </div>
                <div className="it-card-footer">
                  {isDisabled ? (
                    <div className="col-lg-12 text-right">
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-toggle="tooltip"
                        data-placement="top"
                        onClick={() => setIsDisabled(!isDisabled)}
                        title="Modifica"
                      >
                        Modifica
                      </button>
                    </div>
                  ) : (
                    <>
                      <div className="col-lg-10 text-right">
                        <button
                          type="button"
                          className="btn btn-info text-white"
                          data-toggle="tooltip"
                          data-placement="top"
                          onClick={() => setIsDisabled(!isDisabled)}
                          title="Indietro"
                        >
                          Indietro
                        </button>
                      </div>
                      <div className="col-lg-2 text-right">
                        <button
                          type="button"
                          className="btn btn-primary"
                          data-toggle="tooltip"
                          data-placement="top"
                          onClick={() => userEditValidation()}
                          title="Conferma"
                        >
                          Conferma
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-12">
          <div className="card-wrapper card-space">
            <div className="card card-bg no-after card-big roundedCustom">
              <div className="card-body" key="isee" ref={ref}>
                <div className="row">
                  <div className="col-lg-9">
                    <h5>Storico ISEE</h5>
                  </div>
                </div>

                {userIseesTemp && userIsees && userIsees.length > 0 ? (
                  userIsees.map((x) => (
                    <div key={x.id}>
                      <div className="row mt-4">
                        <div className="col-lg-3">
                          Valore ISEE:
                          <strong>
                            {x.value &&
                              parseFloat(x.value).toLocaleString("it-IT", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            &nbsp;€
                          </strong>
                        </div>
                        <div className="col-lg-3">
                          Data inserimento: <strong>{x.date}</strong>
                        </div>
                        <div className="col-lg-3">
                          Data scadenza: <strong>{x.scadenza}</strong>
                        </div>

                        <div className="col-lg-3">
                          Anno: <strong>{x.year} </strong>
                          {x.state == "VALIDATED" ? (
                            <>
                              <b className="text-success">
                                <svg className="icon icon-success">
                                  <use href={`${iconSprite}#it-check-circle`} />
                                </svg>{" "}
                                ACCETTATO
                              </b>
                            </>
                          ) : x.state == "LOADED" ? (
                            <b className="">
                              <svg className="icon">
                                <use href={`${iconSprite}#it-close-circle`} />
                              </svg>
                              DA VERIFICARE
                            </b>
                          ) : x.state == "REFUSED" ? (
                            <b className="text-danger">
                              <svg className="icon icon-danger">
                                <use href={`${iconSprite}#it-close-circle`} />
                              </svg>{" "}
                              RIFIUTATO
                            </b>
                          ) : (
                            <b className="text-danger">
                              <svg className="icon icon-danger">
                                <use href={`${iconSprite}#it-close-circle`} />
                              </svg>{" "}
                              {y.state}
                            </b>
                          )}
                        </div>
                      </div>
                      <hr></hr>
                    </div>
                  ))
                ) : (
                  <>Non sono presenti ISEE</>
                )}
                {userIseesTemp && (
                  <div className="mt-3">
                    <Pagination
                      items={userIseesTemp}
                      setCurrentItems={setUserIsees}
                      itemsPerPage={5}
                    ></Pagination>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <ListPaymemtsUsers
          payments={payments}
          paymentsTemp={paymentsTemp}
          setPayments={setPayments}
        />

        <ModalComponent
          toggleModal={toggleModal}
          isOpen={isOpen}
          header={"Modifica utente: " + user.firstName + " " + user.lastName}
          body={
            "Confermi di voler modificare i dati di " +
            user.firstName +
            " " +
            user.lastName +
            "?"
          }
          buttonConfirm="Conferma"
          buttonDeny="Annulla"
          function={() => editUserAPI()}
        ></ModalComponent>
      </div>
    </>
  );
}

export default UserProfile;
